import { MS_LOCATION } from "../../constants/constants";
import { isNullOrUndefined } from './CommonFunctions';

export const RTCICall = function(args) {
  let touchPointData = JSON.parse(window.tpRequest.tpReq);
  let requestJSON = {
    annExchange: [
      {
        version: "v1",
        resource: "omnichanneltouchpoints"
      }
    ],
    header: {
      requestingsystem: args.app_channel ? args.app_channel : args.app_n_channel,
      ApplicationId: args.app_channel ? args.app_channel : args.app_n_channel,
      ChannelId: args.app_n_channel,
      ApplicationName: args.app_contact ? args.app_contact : args.app_n_channel,
      AppServerName: args.app_n_channel,
      AppServerIP: args.app_n_channel,
      AppServerTimeStamp: touchPointData.header.appServertimestamp, //dynamic
      IntentCategory: args.intentCategory,
      Intent: args.intent,
      TrackingInfo: {
        "-TrackingId": touchPointData.header.trackinginfo.trackingid, //dynamic
        "-SessionId": touchPointData.header.trackinginfo.sessionid, //dynamic
        "-GlobalSessionId": window.tpRequest.idMap.gsid, //dynamic
        "-CallId": "",
        "-PegaSessionId": args.pegaSessionID,
      },
      IntentOutcome: "success"
    },
    identifier: {
      Interaction: {
        StartTime: touchPointData.identifier.interaction.starttime,
        InitiationType: "CUSTOMER_INITIATED",
        CustomerInfo: {
          Type: "Existing",
          AuthType: isNullOrUndefined(window.userinfo) ? "0" : "1",
          Attribute: [
            {
              "-Name": "USERID",
              "#text": args.userid
            },
            {
              "-Name": "VZID",
              "#text": ""
            },
            {
              "-Name": "PCAN",
              "#text": ""
            },
            {
              "-Name": "VISIONID",
              "#text": args.visionID + args.accountID
            },
            {
              "-Name": "DEVICEOS",
              "#text": args.os
            },
            {
              "-Name": "APPVERSION",
              "#text": ""
            },
            {
              "-Name": "ORDERTYPE",
              "#text": ""
            },
            {
              "-Name": "MON",
              "#text": ""
            },
            {
              "-Name": "VISION_CUST_ID",
              "#text": args.visionID
            },
            {
              "-Name": "VISION_ACCT_ID",
              "#text": args.accountID
            }
          ]
        },
        Activity: [
          {
            Category: args.activityCategory,
            Type: args.intent,
            StartTime: touchPointData.identifier.interaction.activity[0].starttime,
            CorrelationInfo: {
              ChannelName: "",
              CorrelationID: ""
            },
            InteractedAsset: {
              WebURL: window.location.href, //dynamic
              PageName: args.intent,
              PageId: "",
              NavgationPath: window.location.pathname,
              AssetId: args.intent,
              IMGMenu: "",
              IVRUVoicePrompts: ""
            },
            Payload: {
              Other: {
                FunctionalCategory: {
                  TransactionType: "",
                  DataElements: [
                    {
                      Data: {
                        Attribute: [
                          {
                            "-Name": args.contact_category ? args.contact_category : "ActionID",
                            "#text": ""
                          },
                          {
                            "-Name": "CardID",
                            "#text": ""
                          },
                          {
                            "-Name": "OutageType",
                            "#text": args.outagetype
                          }
                        ],
                        "-Name": ""
                      }
                    }
                  ],
                  TransactionStatus: "Success",
                  "-Name": args.contact_category ? args.contact_category : ( args.homepage_name ? args.homepage_name : (args.equipment_name ? args.equipment_name : args.intent))
                },
                FunctionalSubCategory: getSubCategory(args),
                // TransactionCommitted: ""
              },
              "-ChannelName": args.app_contact ? args.app_contact : args.app_n_channel,
              Priority: ""
            },
            Status: "Success"
          }
        ]
      }
    }
  };
  // Retry mechanism for constructedtouchpoint **
  let url = MS_LOCATION + "/constructedtouchpoint";
    let options = {
      method: "POST",
      headers: new Headers({
        "content-type": "application/json"
      }),
      body: JSON.stringify(requestJSON)
    };
    let n = 4;
    fetch_retry(url, options, n);
    function fetch_retry(url, options, n) {
      return fetch(url, options)
      .then(function(response){
        return  ((n-1) > 1 && response.status != 200) ? fetch_retry(url, options, n-1 ) : ''; 
      })
      .catch(function (error) {
        console.log(error);
      });
    }
  // **
};


export const MetricRTCICall = (args , linkTrack) => {
  let isValidUser = document.cookie.indexOf('userinfo') > -1 ? true : false;
  let touchPointData = "";
  if(isValidUser) {
    touchPointData = JSON.parse(window.tpRequest.tpReq);
  }
  let metricsJSON = {
    annExchange: [
      {
        version: "v1",
        resource: "omnichanneltouchpoints"
      }
    ],
    header: {
      requestingsystem: "ESUPPORT",
      ApplicationId: "ESUPPORT",
      ChannelId: "ESUPPORT",
      ApplicationName: "ESUPPORT",
      AppServerName: "ESUPPORT",
      AppServerIP: "ESUPPORT", 
      AppServerTimeStamp: "", //dynamic
      IntentCategory: "NBA_CLICK",
      Intent: "ESUPPORT",
      TrackingInfo: {
        "-TrackingId": (isValidUser) ? touchPointData.header.trackinginfo.trackingid : "", //dynamic
        "-SessionId": (isValidUser) ? touchPointData.header.trackinginfo.sessionid : "", //dynamic
        "-GlobalSessionId": (isValidUser) ? window.tpRequest.idMap.gsid : "", //dynamic
        "-CallId": "",
        "-PegaSessionId": args.pegaSessionID,
      },
      IntentOutcome: "success"
    },
    identifier: {
      Interaction: {
        StartTime: (isValidUser) ? touchPointData.identifier.interaction.starttime : "",
        InitiationType: "CUSTOMER_INITIATED",
        CustomerInfo: {
          Type: "Existing",
          AuthType: isNullOrUndefined(window.userinfo) ? "0" : "1",
          Attribute: [
            {
              "-Name": "USERID",
              "#text": args.userid
            },
            {
              "-Name": "VZID",
              "#text": ""
            },
            {
              "-Name": "PCAN",
              "#text": ""
            },
            {
              "-Name": "VISIONID",
              "#text": args.visionID + args.accountID
            },
            {
              "-Name": "DEVICEOS",
              "#text": args.os
            },
            {
              "-Name": "APPVERSION",
              "#text": ""
            },
            {
              "-Name": "ORDERTYPE",
              "#text": ""
            },
            {
              "-Name": "MON",
              "#text": ""
            },
            {
              "-Name": "VISION_CUST_ID",
              "#text": args.visionID
            },
            {
              "-Name": "VISION_ACCT_ID",
              "#text": args.accountID
            }
          ]
        },
        Activity: [
          {
            Category: "NBA_CLICK",
            Type: "PPSH_GENERIC_ONTBAT",
            StartTime: (isValidUser) ? touchPointData.identifier.interaction.activity[0].starttime : "",
            CorrelationInfo: {
              ChannelName: "",
              CorrelationID: ""
            },
            InteractedAsset: {
              WebURL: window.location.href, //dynamic
              PageName: "PPSH_GENERIC_ONTBAT",
              PageId: "",
              NavgationPath: window.location.pathname,
              AssetId: "PPSH_GENERIC_ONTBAT",
              IMGMenu: "",
              IVRUVoicePrompts: ""
            },
            Payload: {
              Other: {
                FunctionalCategory: {
                  TransactionType: "",
                  DataElements: [
                    {
                      Data: {
                        Attribute: [
                          {
                            "-Name": "ActionID",
                            "#text": ""
                          },
                          {
                            "-Name": args.category,
                            "#text": linkTrack
                          }
                        ],
                        "-Name": ""
                      }
                    }
                  ],
                  TransactionStatus: "Success",
                  "-Name": linkTrack
                },
                FunctionalSubCategory: getSubCategory(args),
              },
              "-ChannelName":  "ESUPPORT_CONTACTUS",
              Priority: ""
            },
            Status: "Success"
          }
        ]
      }
    }
  };

  fetch(MS_LOCATION + "/constructedtouchpoint", {
    method: "POST",
    headers: new Headers({
      "content-type": "application/json"
    }),
    body: JSON.stringify(metricsJSON)
  });
}

export const getSubCategory = (args) => {
  var subCategory = {} ;
  if(window.location.href.indexOf('contactus') > -1) {
    subCategory = {
      nctionalCategory: {
        TransactionType: "",
        DataElements: [
          {
            Data: {
              Attribute: [
                {
                  "-Name": "ActionID",
                  "#text": ""
                },
                {
                  "-Name": args.subCategory,
                  "#text": ""
                }
              ],
              "-Name": ""
            }
          }
        ],
        TransactionStatus: "Success",
        "-Name": "PPSH_GENERIC_ONTBAT"
    }
  }
  } else {
    subCategory = null;
  }
  return subCategory;
}


// WEBPACK FOOTER //
// ./src/components/modules/RTCICall.js